/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:22:33
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare उघडा",
    name2: "आरक्षण करा",
    name3: "Carlcare सोबत, आपण आपली ऑर्डर कधीही तपासू शकता.",
    name4: "",
    name5: "उजवीकडे स्लाईड करा",
    name6: "पडताळणी पूर्ण",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "डिव्हाइस मॉडेल निवडा",
    name2: "दोष वर्णन:",
    name3: "सेवा स्टोअर निवडण्यासाठी टॅप करा",
    name4: "सेवा स्टोअर:",
    name5: "आरक्षण वेळ:",
    name6: "कृपया आपल्या डिव्हाइस समस्येचे विस्तार मध्ये विवरण द्या!",
    name7: "आगमनाची वेळ निवडण्यासाठी टॅप करा",
    name8: "कृपया आपला योग्य तपशील प्रविष्ट करा जेणेकरून आम्ही आपल्यापर्यंत पोहोचू शकू",
    name9: "उपलब्ध आरक्षण वेळ पुढील प्रमाणे",
    name10: "कृपया आपला फोन क्रमांक प्रविष्ट करा",
    name11: "किंमत",
    name12: "वैयक्तिक माहिती:",
    name13: "कृपया आपले नाव प्रविष्ट करा",
    name14: "सबमिट करा",
    name15: "रद्द करा",
    name16: "ठीक आहे",
  },
  shops: {
    name1: "आपल्या ब्रँड निवडीवर आधारित, पुढील स्टोअर आपल्याला सेवा देऊ शकतात!",
    name2: "अधिक रीटेल स्टोअर मध्ये लवकरच येत आहे! आमच्यासोबत रहा!",
  },
  price: {
    name1: "ब्रँड",
    name2: "मॉडेल",
    name3: "आयटम",
    name4: "किंमत",
    name5: "मैत्रीपूर्ण स्मरणपत्र:",
    name6: "या किंमती फक्त संदर्भासाठी आहेत आणि वास्तविक किंमत आपल्या डिव्हाइसच्या शर्तीच्या अधीन आहे.",
    name7: "येथे कोणतेही विशेष चिन्ह नसल्यास, किंमतीचे एकक म्हणजे स्थानिक चलनाचे एकक होय.",
    name8: "क्षमस्व! वर्तमान क्षेत्रासाठी कुठलीही किमतीची माहिती उपलब्ध नाही.",
    name11:"मजुरी",
    name12:"एकूण किंमत",
    name13: "5. जर मजुरी \"/\" असेल तर त्याचा अर्थ असा की मजुरीविषयी स्टोअरशी सल्ला मसलत करणे आवश्यक आहे.",
    item_main_board: "मेनबोर्ड",
    item_screen_frame: "स्क्रीन (फ्रेम)",
    item_screen_screen_frame: "दुय्यम स्क्रीन (फ्रेम)",
    item_touch_screen: "टच स्क्रीन",
    item_camera: "\"कॅमेरा\"",
    item_fixed_focus_camera: "फिक्स्ड फोकस कॅमेरा",
    item_auto_focus_camera: "ऑटो फोकस कॅमेरा",
    item_screen: "स्क्रीन",
    item_secondary_screen: "दुय्यम स्क्रीन",
    item_fingerprint_module: "फिंगरप्रिंट मोड्यूल",
    item_speaker: "स्पीकर",
    item_receiver: "प्राप्तकर्ता",
    item_small_board: "लहान बोर्ड",
    item_battery_cover: "बॅटरी कव्हर",
    item_battery: "बॅटरी",
    item_charger: "चार्जर",
    item_usb_cable: "USB केबल",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "डेटा नाही",
    name2: "सेवा प्रदाता:",
    name3: "सेवा ब्रँड:",
    name4: "टेलिफोन:",
    name5: "ऑर्डरचे प्रमाण:",
    name6: "सेवा रेटिंग",
    name7: "सेवा वातावरण:",
    name8: "सेवा प्रवृत्ती:",
    name9: "सेवा कार्यक्षमता:",
    name10: "सेवा दर्जा:",
    name11: "ग्राहक मूल्यांकन",
    name12:"ते",
    name13:"बंद केले",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare उघडा",
    name1: "कृपया आरक्षण माहितीचा स्क्रीनशॉट घ्या आणि प्राधान्यता सेवा अॅक्सेस करण्यासाठी तो पावती म्हणून जतन करा.",
    name2: "यशस्वीरीत्या प्रविष्ट केले",
    name3: "1. डेटा साफ करा",
    name4: "कृपया महत्त्वाचा खाजगी डेटा आपल्या फोनवर आधीच बॅक अप करा",
    name5: "2. पॉवर-चालू संकेतशब्द अक्षम करा",
    name6: "सेवा स्टोअर मध्ये जाण्यापूर्वी, कृपया:",
    name7: "सेवा स्टोअर:",
    name8: "आरक्षण वेळ:",
    name9: "दोष वर्णन:",
    name10: "डिव्हाइस मॉडेल:",
    name11: "ऑर्डर नंबर:",
    name12: "ऑर्डर माहिती",
  },
  title: {
    
    name1: "पुढील देशांना समर्थित करते:",
    name2: "मॉडेल निवडा",
    name3: "आरक्षण",
    name4: "सेवा स्टोअर तपशील",
    name5: "सेवा स्टोअर निवडा",
  },
  error: {
    
    name1: "कोणताही डेटा नाही. कृपया आपली दुरूस्ती माहिती तपासा",
    name2: "अधिक मदतीची आवश्यकता आहे का? कृपया आमच्याशी संपर्क साधा.",
    name3: "क्षमस्व, वर्तमान क्षेत्रात कुठलेही Carlcare केंद्र नाही.",
    name4: "कृपया पहिले सेवा केंद्र निवडा",
    name5: "अयशस्वी झाले",
    name6: "कृपया पहिले डिव्हाइस मॉडेल निवडा",
    name7: "तपशील",
    name8: "कृपया आपल्या गरजांचे तपशीलवार विवरण द्या",
    name9: "",
  },
  add1:{
    "name0": "mr-rIN",
    "name1": "आपल्या ऑर्डरची पुष्टी केली गेली आहे. आम्ही आपल्या आगमनासाठी उत्सुक आहोत.",
    "name2": "शहर निवडा",
    "name3": "कृपया %1$s अंकांचा फोन नंबर इनपुट करा.",
    "name4": "आठवड्यातील दिवसाचे तास",
    "name5": "\"सोमवार\"",
    "name6": "मंगळवार",
    "name7": "बुधवार",
    "name8": "गुरूवार",
    "name9": "शुक्रवार",
    "name10": "\"शनिवार\"",
    "name11": "\"रविवार\"",
    "name12": "देश प्रविष्ट करा आणि शोधा"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "इतर",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"पुनर्निर्देशन करण्यासाठी टॅप करा",
    name3:"ऑर्डरला रेटिंग देण्यासाठी Carlcare ॲप उघडा",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"सेवा निवडा",
    name7:"मोफत स्वच्छता",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "चुकीची माहिती",
    "cancelReason1": "वेळेवर पोहोचू शकत नाही",
    "cancelReason2": "डुप्लिकेट ऑर्डर/माझी ऑर्डर नाही",
    "cancelReason3": "अपयश दिसले नाही",
    "cancelReason4": "फक्त चाचणी/चौकशी/इव्हेंट करिता…",
    "cancelReason5": "अधिक किंमत",
    "cancelReason6": "साहित्याची कमतरता",
    "cancelReason7": "विविध किमती नाहीत",
    "cancelReason8": "स्टोअर खूप दूर आहे",
    "cancelReason9": "स्टोअर बंद आहे",
    "cancelReason10": "खराब सेवा वृत्ती",
    "cancelReason11": "बदली/इतर ब्रँड करिता दुरूस्ती",
    "cancelReason12": "स्टोअर शोधू शकत नाही",
    "cancelReason13": "अन्य",
    "cancelOrder": "ऑर्डर रद्द करा",
    "reason_dialog_title": "कृपया रद्द करण्याचे आम्हाला कारण सांगा",
    "Cancel": "रद्द करा",
    "OK": "ठीक आहे",
    "name1": "सत्यापन कोड प्रविष्\u200dट करा",
    "name2": "अवैध सत्यापन कोड",
    "repair_reservation_detail_canceled": "ऑर्डर रद्द केली गेली आहे!",
    "purchase_cancel_dialog_content": "तुम्हाला ऑर्डर रद्द करण्याची पुष्टी करायची आहे का?",
    "yes": "होय",
    "no": "नाही"
}
};
